/* K MANNAM v11 — independent accessible collection tabs, including theme-editor reloads. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('km-collection-tabs')) return;
  class KMCollectionTabs extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._tabs = Array.from(this.querySelectorAll('[data-kmc-tab]'));
      this._panels = Array.from(this.querySelectorAll('[data-kmc-panel]'));
      this._section = this.closest('.kmc');
      this._viewAll = this._section && this._section.querySelector('[data-kmc-view-all]');
      this._onClick = event => {
        const tab = event.target.closest('[data-kmc-tab]');
        if (!tab || !this.contains(tab) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.select(tab.getAttribute('aria-controls'));
      };
      this._onKey = event => {
        const tab = event.target.closest('[data-kmc-tab]');
        if (!tab || !this._tabs.includes(tab)) return;
        let index = this._tabs.indexOf(tab);
        if (event.key === 'ArrowRight') index = (index + 1) % this._tabs.length;
        else if (event.key === 'ArrowLeft') index = (index - 1 + this._tabs.length) % this._tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this._tabs.length - 1;
        else if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); this.select(tab.getAttribute('aria-controls')); return; }
        else return;
        event.preventDefault();
        this.select(this._tabs[index].getAttribute('aria-controls'));
        this._tabs[index].focus();
      };
      this._onBlockSelect = event => {
        const blockId = event.detail && event.detail.blockId;
        const sectionId = event.detail && event.detail.sectionId;
        if (sectionId && this._section && sectionId !== this._section.dataset.sectionId) return;
        const panel = this._panels.find(item => item.dataset.blockId === blockId);
        if (panel) this.select(panel.id);
      };
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKey);
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      this.setAttribute('data-enhanced', 'true');
      const initial = this._tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this._tabs[0];
      if (initial) this.select(initial.getAttribute('aria-controls'));
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKey);
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
      this._ready = false;
    }
    select(id) {
      const panel = this._panels.find(item => item.id === id);
      if (!panel) return;
      this._panels.forEach(item => { item.hidden = item !== panel; });
      this._tabs.forEach(tab => {
        const selected = tab.getAttribute('aria-controls') === id;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      if (this._viewAll) {
        const url = panel.dataset.viewAllUrl;
        this._viewAll.hidden = !url;
        if (url) this._viewAll.setAttribute('href', url);
        else this._viewAll.removeAttribute('href');
      }
      // Existing theme lazysizes skips hidden panels: check the newly-visible images.
      if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
      panel.querySelectorAll('km-product-countdown').forEach(timer => {
        if (typeof timer.update === 'function') timer.update(Date.now());
      });
      this.dispatchEvent(new CustomEvent('kmannam:collection-change', { bubbles: true, detail: { panelId: id } }));
    }
  }
  customElements.define('km-collection-tabs', KMCollectionTabs);
})();
